// TODO: i18n
export const generateTimestampString =  (timestamp: number) => {
  const date = new Date(timestamp);

  return (
    <>
      {date.toLocaleDateString()} {date.toLocaleTimeString(undefined, {
        hour: "numeric",
        minute: "numeric",
      })}
    </>
  )
}
